module.exports = __webpack_public_path__ + "1434b6ffbd486153e3bf429a6abe3be6.svg";